import request from '@/utils/request';

//活跃会员
export function getActiveMember() {
  return request('/members/board/active-member', {
    method: 'GET',
  });
}
//首购会员
export function getFirstPurchaser() {
  return request('/members/board/first-purchaser', {
    method: 'GET',
  });
}
//复购会员
export function getRepeatPurchaser() {
  return request('/members/board/repeat-purchaser', {
    method: 'GET',
  });
}
//总积分
export function getPointProduce() {
  return request('/members/board/point-produce', {
    method: 'GET',
  });
}
//核销积分
export function getPointConsume() {
  return request('/members/board/point-consume', {
    method: 'GET',
  });
}
// 会员总量member-statistics
export function getMemberStatistics() {
  return request('/members/board/member-statistics', {
    method: 'GET',
  });
}
//积分变化趋势
export function getPointTrend() {
  return request('/members/board/point-trend', {
    method: 'GET',
  });
}
//积分获取方式
export function getAddPointWay() {
  return request('/members/board/add-point-way', {
    method: 'GET',
  });
}
//积分扣减方式
export function getSubtractPointWay() {
  return request('/members/board/subtract-point-way', {
    method: 'GET',
  });
} //活跃会员积分核销比
export function getRate() {
  return request('/members/board/rate', {
    method: 'GET',
  });
}
//商品件数构成
export function getGoodsTrend() {
  return request('/members/board/goods-trend', {
    method: 'GET',
  });
}
//会员客单价
export function getGuestUnitPrice() {
  return request('/members/board/guest-unit-price', {
    method: 'GET',
  });
}
//会员客单价
export function getMemberOrderAssemble() {
  return request('/members/board/member-order', {
    method: 'GET',
  });
}
